module.exports = __webpack_public_path__ + "img/img_ia_gpdf.444f4e5f.png";